/**
 * PrivacyPolicyPage.js — Web /privacy route.
 *
 * Copy is read from the single source of truth at `../legal/legalContent` so
 * the web in-app page, the static `/privacy.html` (generated), and the mobile
 * in-app screen (generated) can never drift. To edit the policy text, change
 * `src/legal/legalContent.js` then run `node scripts/gen-legal-html.js`.
 */
import LegalDoc from '../components/legal/LegalDoc';
import { PRIVACY } from '../legal/legalContent';

export default function PrivacyPolicyPage() {
  return (
    <LegalDoc
      doc={PRIVACY}
      testId="privacy-page"
      otherLink={{ href: '/terms', label: 'Terms of Service' }}
    />
  );
}
